import { Link, useLocation } from 'react-router-dom';

const CATEGORY_MENUS = [
  { label: '예복', href: '/list/suit' },
  { label: '예물', href: '/list/jewelry' },
  { label: '한복', href: '/list/hanbok' },
] as const;

function getActiveMenu(pathname: string): string | null {
  if (
    pathname.startsWith('/yangbok') ||
    pathname.startsWith('/shops/suit') ||
    pathname.includes('partner-shops')
  ) {
    return '예복';
  }
  if (
    pathname.startsWith('/yemul') ||
    pathname.startsWith('/shops/jewelry')
  ) {
    return '예물';
  }
  if (
    pathname.startsWith('/hanbok') ||
    pathname.startsWith('/shops/hanbok')
  ) {
    return '한복';
  }
  return null;
}

export default function AppHeader({ minimal = false }: { minimal?: boolean }) {
  const location = useLocation();
  const activeMenu = getActiveMenu(location.pathname);

  if (minimal) {
    return (
      <header className="sticky top-0 z-50 bg-white border-b border-[#E8E2DA]">
        <div className="flex items-center justify-between h-14 px-4 max-w-[1200px] mx-auto">
          <Link to="/" className="flex items-center gap-2 text-sm text-[#536079] hover:text-[#121B35] transition-colors cursor-pointer">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-left-line text-lg"></i>
            </div>
            <span className="whitespace-nowrap">뒤로가기</span>
          </Link>
          <Link to="/" className="text-sm font-semibold text-[#121B35] whitespace-nowrap cursor-pointer">
            다이렉트 인증업체
          </Link>
          <div className="w-[60px]" />
        </div>
      </header>
    );
  }

  return (
    <header className="sticky top-0 z-50 bg-white border-b border-[#E8E2DA]">
      {/* Desktop: single row */}
      <div className="hidden lg:flex items-center justify-between h-16 px-6 max-w-[1200px] mx-auto">
        {/* Left: Logo + Badge */}
        <Link to="/" className="flex items-center gap-3 shrink-0 cursor-pointer">
          <span className="text-lg font-bold text-[#121B35] whitespace-nowrap tracking-tight">
            다이렉트 인증업체
          </span>
          <span className="text-[11px] text-[#B9965B] bg-[#F7F2EA] border border-[#E8E2DA] rounded-full px-2.5 py-0.5 font-medium whitespace-nowrap">
            실제 후기 기반
          </span>
        </Link>

        {/* Center: Category navigation */}
        <nav className="flex items-center gap-1">
          {CATEGORY_MENUS.map((menu) => {
            const isActive = activeMenu === menu.label;
            return (
              <Link
                key={menu.label}
                to={menu.href}
                className={`px-4 py-2 text-sm font-medium rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer ${
                  isActive
                    ? 'bg-[#121B35] text-white'
                    : 'text-[#536079] hover:text-[#121B35] hover:bg-[#F7F2EA]'
                }`}
              >
                {menu.label}
              </Link>
            );
          })}
        </nav>

        {/* Right: CTA */}
        <Link
          to="/guide/dress"
          className="bg-[#121B35] text-white text-sm font-medium px-5 py-2.5 rounded-full hover:bg-[#2a3f5f] transition-colors duration-200 whitespace-nowrap shrink-0 cursor-pointer"
        >
          내 취향 찾기
        </Link>
      </div>

      {/* Mobile: two rows */}
      <div className="lg:hidden">
        {/* Row 1: Logo + CTA */}
        <div className="flex items-center justify-between px-4 h-14">
          <Link to="/" className="cursor-pointer">
            <span className="text-base font-bold text-[#121B35] whitespace-nowrap tracking-tight">
              다이렉트 인증업체
            </span>
          </Link>
          <Link
            to="/guide/dress"
            className="bg-[#121B35] text-white text-xs font-medium px-4 py-2 rounded-full hover:bg-[#2a3f5f] transition-colors duration-200 whitespace-nowrap shrink-0 cursor-pointer"
          >
            취향 찾기
          </Link>
        </div>

        {/* Row 2: Category tabs */}
        <div className="flex items-center gap-1 px-4 pb-2.5">
          {CATEGORY_MENUS.map((menu) => {
            const isActive = activeMenu === menu.label;
            return (
              <Link
                key={menu.label}
                to={menu.href}
                className={`px-4 py-1.5 text-sm font-medium rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer ${
                  isActive
                    ? 'bg-[#121B35] text-white'
                    : 'text-[#536079] active:bg-[#F7F2EA]'
                }`}
              >
                {menu.label}
              </Link>
            );
          })}
        </div>
      </div>
    </header>
  );
}